import SvgIcon from "./IconCaseRxIllustration.svg?react";
const IconCaseRxIllustration = SvgIcon;
export default IconCaseRxIllustration;
